import { ShieldCheck, MessageSquare, Banknote, Wrench } from "lucide-react";

const items = [
  { icon: ShieldCheck, text: "No unnecessary work" },
  { icon: MessageSquare, text: "Clear advice first" },
  { icon: Banknote, text: "Upfront pricing" },
  { icon: Wrench, text: "Quality workmanship" },
];

export function ReassuranceBanner() {
  return (
    <section className="border-y border-border/70 bg-gradient-to-b from-card to-secondary/40 py-5">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-3 md:justify-between">
          {items.map((item, i) => (
            <div key={item.text} className="flex items-center gap-2.5">
              <span className="flex h-7 w-7 items-center justify-center rounded-md bg-primary/10 text-primary">
                <item.icon className="h-3.5 w-3.5" />
              </span>
              <span className="text-[12px] font-bold tracking-[0.12em] uppercase text-foreground/85">
                {item.text}
              </span>
              {i < items.length - 1 && (
                <span className="hidden md:inline-block h-4 w-px bg-border ml-7" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
